import {computed, defineComponent, onMounted, onUnmounted, provide, ref} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapBaseLayer',
    inheritAttrs: true,
    props: {
        tagName: {
            type: String,
            default: 'div'
        },
        modToggle: Boolean
    },
    emits: ['change'],
    setup(props, {emit}) {
        const open = ref(false)
        const classes = computed(() => {
            return ['kl-ol-map-base-layer', {'kl-ol-map-base-layer--open': open.value}, {'kl-ol-map-base-layer--toggle': props.modToggle}]
        })

        function toggleBaseLayer() {
            open.value = !open.value
        }

        function closeBaseLayer() {
            open.value = false
        }

        function handleChangeEvent($event: any, active: boolean) {
            closeBaseLayer()
            emit('change', {$event, active})
        }

        provide('handleChangeEvent', {handleChangeEvent})

        return {
            classes,
            toggleBaseLayer
        }
    }
});
